'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const AcquisitionFunnelInner = dynamic(() => import('./AcquisitionFunnelInner'), { ssr: false });

export default function AcquisitionFunnel() {
  return (
    <div className="card-surface p-5">
      <div className="mb-4">
        <h2 className="text-base font-semibold text-foreground">Acquisition Funnel</h2>
        <p className="text-sm text-muted-foreground">Lead to conversion — May 2026</p>
      </div>
      <AcquisitionFunnelInner />
    </div>
  );
}